<template>
  <ModalFormComponent
    ref="modalForm"
    :models="models"
    :title="modalTitle"
    :hideCancel="true"
    :showCloseButton="false"
    :modalConfig="modalConfig"
    :closeOnSubmit="false"
    @submit="submit"
  >
    <template #formView>
      <BlockLoader :loading="loading" />
      <div class="alert alert-light-info">Vérifiez vos informations et créez votre mot de passe</div>
      <div class="row align-items-end">
        <FormFieldComponent v-for="model in Object.values(models)" :key="model.vars.id" :model="model" />
      </div>
      <PasswordInfoComponent :password="models['password']" />
    </template>
  </ModalFormComponent>
</template>

<script>
import { userManager } from "@/services/security/user-manager";
import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/main/main";
import ModalFormComponent from "@/components/form/ModalFormComponent.vue";
import FormFieldComponent from "@/components/form/FormFieldComponent.vue";
import PasswordInfoComponent from "@/components/form/PasswordInfoComponent.vue";
import { formManager } from "@/services/form/form-manager";
import { loginManager } from "@/services/security/login-manager";
import { useUserStore } from "@/store/user/user";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
export default {
  name: "UserActiveView",
  components: { BlockLoader, PasswordInfoComponent, FormFieldComponent, ModalFormComponent },
  data() {
    return {
      models: {},
      modalTitle: "Première connexion",
      modalConfig: { backdrop: "static", keyboard: false },
      loading: false,
    };
  },
  mounted() {
    this.activateAccount();
  },
  methods: {
    async activateAccount() {
      const response = await userManager.activateAccount();

      if (response && (response.hasError || response.alreadyActive)) {
        const notificationMessage =
          response?.responses && response.responses[0]?.validationErrors[0]?.message
            ? response.responses[0].validationErrors[0].message
            : i18n.global.t("already_active");
        notificationManager.showNotification("success", notificationMessage);
        this.$router.push({ name: "Login" });
      } else {
        this.models = response;
        this.setAppLoading(false);
      }
    },

    async submit() {
      const result = formManager.processForm(this.models);
      this.loading = true;
      const response = await userManager.postUserFirstConnection(result);
      if (response && response.token) {
        this.clearQueryParamsFromUrl();
        setTimeout(() => {
          this.setAppLoading(true);
          const apiPath = loginManager.getApiPath();
          loginManager.setToken(response, apiPath);
          this.fetchUserInfos().then(() => {
            this.$refs.modalForm.cancel();
            loginManager.redirect();
          });
        }, 50);
      }
      this.loading = true;
    },

    clearQueryParamsFromUrl() {
      this.$router.push({ name: this.$route.name });
    },

    ...mapActions(useMainStore, {
      setAppLoading: "setAppLoading",
    }),
    ...mapActions(useUserStore, { fetchUserInfos: "fetchUserInfos" }),
  },
};
</script>

<style lang="scss" scoped></style>
